import React from 'react';
import PropTypes from 'prop-types';
import AvailableLanguageLink from '../AvailableLanguageLink';
import { Link } from 'src/components/Inputs';
import {
  intro,
  tableOfContentsTitle,
  sections,
} from 'src/store/developer-policy-de.js';
import { toKebabCase } from 'src/lib/utils';

const propTypes = {
  availableLanguages: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ),
};

const DeVersion = ({ availableLanguages }) => {
  return (
    <>
      <h4 id='richtlinie-fur-entwickler'>{intro.title}</h4>
      <p>Available languages:</p>
      <ul>
        {availableLanguages.map((language, i) => {
          return (
            <AvailableLanguageLink
              key={`language-${i}`}
              href={language.href}
              label={language.label}
            />
          );
        })}
      </ul>
      <br />
      <br />
      <p dangerouslySetInnerHTML={{ __html: intro.effectiveDate }} />
      {Array.isArray(intro.description)
        ? intro.description?.map((paragraph, i) => {
            return <p key={`paragraph-${i}`}>{paragraph}</p>;
          })
        : intro?.description}
      <p>
        <em>{tableOfContentsTitle}</em>
      </p>
      {sections.map((section, i) => {
        return (
          <p key={`table-content-${i}`}>
            <Link href={`#${toKebabCase(section.title) || section?.id}`}>
              <a data-smooth-scroll data-offset='80'>
                {section.title}
              </a>
            </Link>
          </p>
        );
      })}
      {sections.map((section, i) => {
        return (
          <React.Fragment key={`section-title-${i}`}>
            <h5 id={toKebabCase(section.title) || section?.id}>
              {section.title}
            </h5>

            {Array.isArray(section?.description) ? (
              section?.description?.map((desc, i) => {
                if (Array.isArray(desc)) {
                  return (
                    <ul key={`section-description-${i}`}>
                      {desc.map((listItem, i) => {
                        return (
                          <li
                            key={`section-listItem-${i}`}
                            dangerouslySetInnerHTML={{
                              __html: listItem,
                            }}
                          />
                        );
                      })}
                    </ul>
                  );
                } else {
                  return (
                    <p
                      key={`section-description-${i}`}
                      dangerouslySetInnerHTML={{ __html: desc }}
                    />
                  );
                }
              })
            ) : (
              <p key={`section-description-${i}`}>{section?.description}</p>
            )}
          </React.Fragment>
        );
      })}
    </>
  );
};

DeVersion.propTypes = propTypes;
export default DeVersion;
